export function replacePathParams(path: string, params: Record<string, string> | undefined) {
  if (!params) {
    return path;
  }

  return path.replace(/:(\w+)/g, (_, param) => params[param] ?? "");
}
